import { injectGlobal } from 'styled-components';
import AvenirNextRegularTTF from '../media/fonts/avenir-next-regular.ttf';
import AvenirNextRegularWoff from '../media/fonts/avenir-next-regular.woff';
import AvenirNextThinTTF from '../media/fonts/avenir-next-thin.ttf';
import AvenirNextThinWoff from '../media/fonts/avenir-next-thin.woff';
import AvenirNextBoldTTF from '../media/fonts/avenir-next-bold.ttf';
import AvenirNextBoldWoff from '../media/fonts/avenir-next-bold.woff';
import AvenirNextItalicTTF from '../media/fonts/avenir-next-italic.ttf';
import AvenirNextItalicWoff from '../media/fonts/avenir-next-italic.woff';
import AvenirNextMediumOTF from '../media/fonts/avenir-next-lt-pro-medium.otf';
import GTWalsheimProThin from '../media/fonts/GT-Walsheim-Pro-Thin.woff';
import GTWalsheimProLight from '../media/fonts/GT-Walsheim-Pro-Light.ttf';
import GTWalsheimProRegularTTF from '../media/fonts/GT-Walsheim-Pro-Regular.ttf';
import GTWalsheimProRegularWoff from '../media/fonts/GT-Walsheim-Pro-Regular.woff';
import GTWalsheimProMedium from '../media/fonts/GT-Walsheim-Pro-Medium.ttf';
import GTWalsheimProBold from '../media/fonts/GT-Walsheim-Pro-Bold.ttf';
import GTWalsheimProUltraBold from '../media/fonts/GT-Walsheim-Pro-Ultra-Bold.ttf';
import GTWalsheimProUltraBoldOblique from '../media/fonts/GT-Walsheim-Pro-Ultra-Bold-Oblique.ttf';
import PoppinsThin from '../media/fonts/Poppins/Poppins-Thin.ttf';
import PoppinsThinItalic from '../media/fonts/Poppins/Poppins-ThinItalic.ttf';
import PoppinsExtraLight from '../media/fonts/Poppins/Poppins-ExtraLight.ttf';
import PoppinsExtraLightItalic from '../media/fonts/Poppins/Poppins-ExtraLightItalic.ttf';
import PoppinsLight from '../media/fonts/Poppins/Poppins-Light.ttf';
import PoppinsLightItalic from '../media/fonts/Poppins/Poppins-LightItalic.ttf';
import PoppinsRegular from '../media/fonts/Poppins/Poppins-Regular.ttf';
import PoppinsRegularItalic from '../media/fonts/Poppins/Poppins-RegularItalic.ttf';
import PoppinsMedium from '../media/fonts/Poppins/Poppins-Medium.ttf';
import PoppinsMediumItalic from '../media/fonts/Poppins/Poppins-MediumItalic.ttf';
import PoppinsSemiBold from '../media/fonts/Poppins/Poppins-SemiBold.ttf';
import PoppinsSemiBoldItalic from '../media/fonts/Poppins/Poppins-SemiBoldItalic.ttf';
import PoppinsBold from '../media/fonts/Poppins/Poppins-Bold.ttf';
import PoppinsBoldItalic from '../media/fonts/Poppins/Poppins-BoldItalic.ttf';
import PoppinsExtraBold from '../media/fonts/Poppins/Poppins-ExtraBold.ttf';
import PoppinsExtraBoldItalic from '../media/fonts/Poppins/Poppins-ExtraBoldItalic.ttf';
import PoppinsBlack from '../media/fonts/Poppins/Poppins-Black.ttf';
import PoppinsBlackItalic from '../media/fonts/Poppins/Poppins-BlackItalic.ttf';

import RubikLight from '../media/fonts/Rubik/Rubik-Light.ttf';
import RubikLightItalic from '../media/fonts/Rubik/Rubik-LightItalic.ttf';

import RubikRegular from '../media/fonts/Rubik/Rubik-Regular.ttf';
import RubikRegularItalic from '../media/fonts/Rubik/Rubik-RegularItalic.ttf';

import RubikMedium from '../media/fonts/Rubik/Rubik-Medium.ttf';
import RubikMediumItalic from '../media/fonts/Rubik/Rubik-MediumItalic.ttf';

import RubikBold from '../media/fonts/Rubik/Rubik-Bold.ttf';
import RubikBoldItalic from '../media/fonts/Rubik/Rubik-BoldItalic.ttf';

import RubikBlack from '../media/fonts/Rubik/Rubik-Black.ttf';
import RubikBlackItalic from '../media/fonts/Rubik/Rubik-BlackItalic.ttf';

injectGlobal`
  @font-face {
    font-family: 'Avenir Next';
    src: url(${AvenirNextThinTTF}) format('truetype');
         url(${AvenirNextThinWoff}) format('woff');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'Avenir Next';
    src: url(${AvenirNextRegularTTF}) format('truetype');
         url(${AvenirNextRegularWoff}) format('woff');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Avenir Next';
    src: url(${AvenirNextMediumOTF}) format('opentype');
    font-weight: 500;
    font-style: normal;
  }


  @font-face {
    font-family: 'Avenir Next';
    src: url(${AvenirNextBoldTTF}) format('truetype');
         url(${AvenirNextBoldWoff}) format('woff');
    font-weight: 700;
    font-style: bold;
  }

  @font-face {
    font-family: 'Avenir Next';
    src: url(${AvenirNextItalicTTF}) format('truetype');
         url(${AvenirNextItalicWoff}) format('woff');
    font-weight: normal;
    font-style: italic;
  }

  @font-face {
    font-family: 'GT Walsheim Pro';
    src: url(${GTWalsheimProThin}) format('woff');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'GT Walsheim Pro';
    src: url(${GTWalsheimProLight}) format('truetype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'GT Walsheim Pro';
    src: url(${GTWalsheimProRegularTTF}) format('truetype');
         url(${GTWalsheimProRegularWoff}) format('woff');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'GT Walsheim Pro';
    src: url(${GTWalsheimProMedium}) format('truetype');
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: 'GT Walsheim Pro';
    src: url(${GTWalsheimProBold}) format('truetype');
    font-weight: 700;
    font-style: normal;
  }

  @font-face {
    font-family: 'GT Walsheim Pro';
    src: url(${GTWalsheimProUltraBold}) format('truetype');
    font-weight: 800;
    font-style: normal;
  }

  @font-face {
    font-family: 'GT Walsheim Pro';
    src: url(${GTWalsheimProUltraBoldOblique}) format('truetype');
    font-weight: 800;
    font-style: italic;
  }

  @font-face {
    font-family: 'Poppins';
    src: url(${PoppinsThin}) format('truetype');
    font-weight: 100;
    font-style: normal;
  }

  @font-face {
    font-family: 'Poppins';
    src: url(${PoppinsThinItalic}) format('truetype');
    font-weight: 100;
    font-style: italic;
  }

  @font-face {
    font-family: 'Poppins';
    src: url(${PoppinsExtraLight}) format('truetype');
    font-weight: 200;
    font-style: normal;
  }

  @font-face {
    font-family: 'Poppins';
    src: url(${PoppinsExtraLightItalic}) format('truetype');
    font-weight: 200;
    font-style: italic;
  }

  @font-face {
    font-family: 'Poppins';
    src: url(${PoppinsLight}) format('truetype');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'Poppins';
    src: url(${PoppinsLightItalic}) format('truetype');
    font-weight: 300;
    font-style: italic;
  }

  @font-face {
    font-family: 'Poppins';
    src: url(${PoppinsRegular}) format('truetype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Poppins';
    src: url(${PoppinsRegularItalic}) format('truetype');
    font-weight: 400;
    font-style: italic;
  }

  @font-face {
    font-family: 'Poppins';
    src: url(${PoppinsMedium}) format('truetype');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'Poppins';
    src: url(${PoppinsMediumItalic}) format('truetype');
    font-weight: 500;
    font-style: italic;
  }

  @font-face {
    font-family: 'Poppins';
    src: url(${PoppinsSemiBold}) format('truetype');
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: 'Poppins';
    src: url(${PoppinsSemiBoldItalic}) format('truetype');
    font-weight: 600;
    font-style: italic;
  }

  @font-face {
    font-family: 'Poppins';
    src: url(${PoppinsBold}) format('truetype');
    font-weight: 700;
    font-style: normal;
  }

  @font-face {
    font-family: 'Poppins';
    src: url(${PoppinsBoldItalic}) format('truetype');
    font-weight: 700;
    font-style: italic;
  }

  @font-face {
    font-family: 'Poppins';
    src: url(${PoppinsExtraBold}) format('truetype');
    font-weight: 800;
    font-style: normal;
  }

  @font-face {
    font-family: 'Poppins';
    src: url(${PoppinsExtraBoldItalic}) format('truetype');
    font-weight: 800;
    font-style: italic;
  }

  @font-face {
    font-family: 'Poppins';
    src: url(${PoppinsBlack}) format('truetype');
    font-weight: 900;
    font-style: normal;
  }

  @font-face {
    font-family: 'Poppins';
    src: url(${PoppinsBlackItalic}) format('truetype');
    font-weight: 900;
    font-style: italic;
  }

  @font-face {
    font-family: 'Rubik';
    src: url(${RubikLight}) format('truetype');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'Rubik';
    src: url(${RubikLightItalic}) format('truetype');
    font-weight: 300;
    font-style: italic;
  }

  @font-face {
    font-family: 'Rubik';
    src: url(${RubikRegular}) format('truetype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Rubik';
    src: url(${RubikRegularItalic}) format('truetype');
    font-weight: 400;
    font-style: italic;
  }

  @font-face {
    font-family: 'Rubik';
    src: url(${RubikMedium}) format('truetype');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'Rubik';
    src: url(${RubikMediumItalic}) format('truetype');
    font-weight: 500;
    font-style: italic;
  }


  @font-face {
    font-family: 'Rubik';
    src: url(${RubikBold}) format('truetype');
    font-weight: 700;
    font-style: normal;
  }

  @font-face {
    font-family: 'Rubik';
    src: url(${RubikBoldItalic}) format('truetype');
    font-weight: 700;
    font-style: italic;
  }

  @font-face {
    font-family: 'Rubik';
    src: url(${RubikBlack}) format('truetype');
    font-weight: 800;
    font-style: normal;
  }

  @font-face {
    font-family: 'Rubik';
    src: url(${RubikBlackItalic}) format('truetype');
    font-weight: 800;
    font-style: italic;
  }
`;



// WEBPACK FOOTER //
// ./src/components/GlobalStyles.js